
jQuery(function () {
  jQuery(".dropdown .button").on('click', function () {
    var dropdown = jQuery(this).parents('.dropdown');
    dropdown.toggleClass('is-active');
    dropdown.focusout(function () {
      jQuery(this).removeClass('is-active');
    });
  });

  jQuery(".navbar-burger").on('click', function () {
    jQuery(".navbar-burger").toggleClass("is-active");
    jQuery("#filters").toggleClass('is-active');
  });
});

export async function getJSON(url) {
  return new Promise((resolve, reject) => {
    jQuery.getJSON(url, function (data) {
      resolve(data);
    }).fail(() => {
      reject();
    });
  });
}